import type { ComponentProps } from "react";

const FirelightIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.01541 0C6.01541 0 5.72567 3.90125 3.01053 6.66956C0.598158 8.63375 0.211831 9.6777 0.0620755 11.159C-0.0887655 12.6468 0.0750976 15.5225 2.79132 17.4845C2.79132 17.4845 1.81465 15.0971 4.22051 13.1362C6.5146 11.2664 6.23136 9.93814 6.19664 9.81552C6.22485 9.9197 6.76853 11.8719 7.95898 12.9821C9.17982 14.1205 9.00076 16.1335 7.84612 18C7.84612 18 11.6009 15.5724 11.934 12.318C12.4723 7.01899 7.76256 0.860553 6.01541 0Z"
        fill={props.fill || "#7D7D7D"}
      />
    </svg>
  );
};

export default FirelightIcon;
